import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1>About The Data Cleaning & Preprocessing Process</h1>
        <p>Learn how this platform ensures your data is clean, accurate, and ready for analysis.</p>
      </section>

      <section className="about-content">
        <h2>The Data Cleaning Process</h2>
        <div className="process-steps">
          <div className="process-step">
            <h3>1. Condense the Dataset</h3>
            <p>Remove rows with high percentages of NaN values to ensure only valuable entries are included.</p>
          </div>
          <div className="process-step">
            <h3>2. Rename Duplicate Columns</h3>
            <p>Rename duplicate columns if they contain different values; otherwise, keep one to reduce redundancy.</p>
          </div>
          <div className="process-step">
            <h3>3. Analyze Features</h3>
            <p>Remove unhelpful features for analysis and training. Convert strings to numeric and fill NaN values with mean, mode, etc. Remove columns if missing values are excessive.</p>
          </div>
          <div className="process-step">
            <h3>4. Remove Duplicate Rows</h3>
            <p>Remove all duplicated rows, keeping only one instance.</p>
          </div>
          <div className="process-step">
            <h3>5. Clean Text Data</h3>
            <p>Remove special characters, convert text to lowercase, and convert null values to empty strings.</p>
          </div>
        </div>

        <h2>The Preprocessing Process</h2>
        <div className="process-steps">
          <div className="process-step">
            <h3>1. Handle Datetime Features</h3>
            <p>Preprocess and encode datetime-like features. Extract useful information from datetime values.</p>
          </div>
          <div className="process-step">
            <h3>2. Unified Text Processing</h3>
            <p>Identify, clean, and encode text columns for consistency.</p>
          </div>
          <div className="process-step">
            <h3>3. Encode Categorical Features</h3>
            <p>Dynamically encode categorical features using one-hot, label, or limited encoding based on their characteristics.</p>
          </div>
          <div className="process-step">
            <h3>4. Handle Outliers</h3>
            <p>Optionally identify and handle outliers in numerical columns using methods like IQR or Z-score.</p>
          </div>
          <div className="process-step">
            <h3>5. Normalize Numerical Features</h3>
            <p>Normalize numerical features to a range of [0, 1] for optimal analysis.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;